import { render, staticRenderFns } from "./Didacticial.vue?vue&type=template&id=5a1f6541&"
import script from "./Didacticial.vue?vue&type=script&lang=js&"
export * from "./Didacticial.vue?vue&type=script&lang=js&"
import style0 from "./Didacticial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports